import React, { useState } from "react";
import {
  Mail,
  Phone,
  MapPin,
  Send,
  Linkedin,
  Github,
  Download,
} from "lucide-react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const resumeUrl = "/resume.pdf";
  const formSubmitEndpoint =
    "https://formsubmit.co/ajax/satyachamana@gmail.com";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch(formSubmitEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject || "Portfolio Contact",
          message: formData.message,
        }),
      });

      if (!response.ok) {
        throw new Error("Email service returned an error");
      }

      setFormData({ name: "", email: "", subject: "", message: "" });
      alert("Thanks for reaching out! Your message is on its way.");
    } catch (error) {
      console.error(error);
      alert(
        "Something went wrong sending your message. Please try again or email satyachamana@gmail.com directly.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: <Mail size={18} />,
      title: "Email",
      value: "satyachamana@gmail.com",
      link: "mailto:satyachamana@gmail.com",
    },
    {
      icon: <Phone size={18} />,
      title: "Phone",
      value: "+1 (616) 426-7409",
      link: "tel:+16164267409",
    },
    {
      icon: <MapPin size={18} />,
      title: "Location",
      value: "San Francisco Bay Area",
      link: "#",
    },
  ];

  const socialLinks = [
    {
      icon: <Linkedin />,
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/satya-chamana/",
    },
    {
      icon: <Github />,
      name: "GitHub",
      url: "https://github.com/SatyaChamana",
    },
  ];

  return (
    <div className="px-[5vw] pt-16 pb-20" style={{ color: 'var(--text)' }}>
      <div className="max-w-3xl">
        <h1 className="text-4xl font-semibold md:text-5xl">Get In Touch</h1>
        <p className="mt-3" style={{ color: 'var(--text-muted)' }}>
          Open to Senior AI/ML, ML Platform, and Applied AI Engineer roles in
          the Bay Area. Recruiters and hiring managers: fastest path is the
          calendar link below or a direct email.
        </p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        <div
          className="rounded-3xl border p-6"
          style={{
            backgroundColor: 'var(--card)',
            borderColor: 'var(--border)',
          }}
        >
          <h2 className="text-2xl font-semibold">Let's Connect</h2>
          <p className="mt-2 text-sm" style={{ color: 'var(--text-muted)' }}>
            Feel free to reach out through any of these channels.
          </p>

          <div className="mt-6 space-y-4">
            {contactInfo.map((info) => (
              <div key={info.title} className="flex items-start gap-3">
                <span
                  className="inline-flex h-9 w-9 items-center justify-center rounded-xl"
                  style={{ backgroundColor: 'var(--pill)' }}
                >
                  {info.icon}
                </span>
                <div>
                  <h3 className="text-sm font-semibold">{info.title}</h3>
                  
                    <a href={info.link}
                    className="text-sm"
                    style={{ color: 'var(--text-muted)' }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {info.value}
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8">
            <h3 className="text-sm font-semibold">Follow Me</h3>
            <div className="mt-3 flex gap-3">
              {socialLinks.map((social) => (
                
                 <><a key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border"
                  style={{
                    borderColor: 'var(--border)',
                    color: 'var(--text)',
                  }}
                  title={social.name}
                >
                  {social.icon}
                </a>
                </> 
              ))}
            </div>
          </div>

          <div
            className="mt-8 rounded-2xl border p-4"
            style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--pill)',
            }}
          >
            <div className="flex items-center justify-between gap-3">
              <div>
                <h3 className="text-base font-semibold">Resume</h3>
                <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
                  Download the latest copy.
                </p>
              </div>
              
                <a href={resumeUrl}
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold"
                style={{
                  backgroundColor: 'var(--accent)',
                  color: 'var(--accent-foreground)',
                }}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <Download size={16} />
                Download
              </a>
            </div>
          </div>
        </div>

        <div
          className="rounded-3xl border p-6"
          style={{
            backgroundColor: 'var(--card)',
            borderColor: 'var(--border)',
          }}
        >
          <h2 className="text-2xl font-semibold">Send a Message</h2>
          <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="text-sm font-semibold">
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
                className="mt-2 w-full rounded-2xl border px-4 py-3 text-sm"
                style={{
                  borderColor: 'var(--border)',
                  backgroundColor: 'var(--pill)',
                  color: 'var(--text)',
                }}
              />
            </div>
            <div>
              <label htmlFor="email" className="text-sm font-semibold">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
                className="mt-2 w-full rounded-2xl border px-4 py-3 text-sm"
                style={{
                  borderColor: 'var(--border)',
                  backgroundColor: 'var(--pill)',
                  color: 'var(--text)',
                }}
              />
            </div>
            <div>
              <label htmlFor="subject" className="text-sm font-semibold">
                Subject
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="What's this about?"
                className="mt-2 w-full rounded-2xl border px-4 py-3 text-sm"
                style={{
                  borderColor: 'var(--border)',
                  backgroundColor: 'var(--pill)',
                  color: 'var(--text)',
                }}
              />
            </div>
            <div>
              <label htmlFor="message" className="text-sm font-semibold">
                Message *
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder="Tell me about your project or inquiry..."
                className="mt-2 w-full rounded-2xl border px-4 py-3 text-sm"
                style={{
                  borderColor: 'var(--border)',
                  backgroundColor: 'var(--pill)',
                  color: 'var(--text)',
                }}
              />
            </div>
            <button
              type="submit"
              className={`inline-flex items-center gap-2 rounded-2xl px-6 py-3 text-sm font-semibold ${
                isSubmitting ? "opacity-60" : ""
              }`}
              style={{
                backgroundColor: 'var(--accent)',
                color: 'var(--accent-foreground)',
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                "Sending..."
              ) : (
                <>
                  <Send size={18} />
                  Send Message
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <div
        className="mt-12 rounded-3xl border px-6 py-8 text-center"
        style={{
          backgroundColor: 'var(--card)',
          borderColor: 'var(--border)',
        }}
      >
        <h3 className="text-2xl font-semibold">Hiring for a senior AI/ML seat?</h3>
        <p className="mt-2 text-sm" style={{ color: 'var(--text-muted)' }}>
          Eight years of production engineering. RAG at sub-50ms, ML at 92% accuracy,
          10K+ users at 99.5% uptime. Let's talk.
        </p>
        <div className="mt-4 flex flex-wrap justify-center gap-3">
          
            <a className="rounded-full px-6 py-2 text-sm font-semibold"
            style={{
              backgroundColor: 'var(--accent)',
              color: 'var(--accent-foreground)',
            }}
             href="https://calendly.com/satyajason143/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            Schedule a Call
          </a>
          
            <a href={resumeUrl}
            className="rounded-full border px-6 py-2 text-sm font-semibold"
            style={{
              borderColor: 'var(--border)',
              color: 'var(--text)',
            }}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;